<li *ngIf="showFilter" class="nav-item" (click)="elementService.openCloseTreeview($event)">
  <a class="nav-link" (click)="callDataRange()">
    <!-- <i *ngIf="item.icon" class="fa fa-{{item.icon}}"></i> -->
    <i class="nav-icon fas fa-calendar-alt"></i>
    <p>Filtro de datas
      <i class="right fas fa-angle-left"></i>
    </p>
    
    
    <!--i class="fa fa-angle-left pull-right"></i-->
  </a>
  <ul class="nav nav-treeview">
    <li class="nav-item"  (click)="elementService.openCloseTreeview($event)">
      <button id="daterange-btn-calendario" 
              class="btn bg-gradient-info nav-link"
            >
            <span></span>
            <i class="float-right fa fa-caret-down"></i>
      </button>
    </li>
  </ul>
</li>

